{
  "title": "Не удалось завершить регистрацию",
  "message": "Не удалось подтвердить вашу личность"
}
